var pdp_related_swiper = new Swiper(".header-best-swiper", {
    slidesPerView: 2.5,
    spaceBetween: 16,
    freeMode: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    scrollbar: {
        el: ".swiper-scrollbar"
    },
});